import Button from "@/common/components/Button";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { FormTransformers } from "@/common/utils/formTransformers";
import { MaintenanceForwardingEstablishmentChoiceEntryData } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/features/forwardings/types/maintenanceForwarding.type";
import { useMaintenanceEstablishmentChoiceManualEntryProposalsClientReject } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/hooks/forwardings/establishmentChoice/manualEntryProposals/useMaintenanceEstablishmentChoiceManualEntryProposalsClientReject";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";

interface ManualEntryProposalsClientRejectProps {
  proposal: MaintenanceForwardingEstablishmentChoiceEntryData['actual_proposal'];
}

const ManualEntryProposalsClientReject = ({
  proposal
}: ManualEntryProposalsClientRejectProps) => {
  const { id } = useParams();

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const queryClient = useQueryClient();

  const {
    mutate: clientReject,
    isPending: clientRejectIsPending,
  } = useMaintenanceEstablishmentChoiceManualEntryProposalsClientReject({
    proposalId: proposal.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['maintenanceWorkflow', id] });
        queryClient.invalidateQueries({ queryKey: ['maintenanceWorkflowForwardings', id] });
        queryClient.invalidateQueries({ queryKey: ['maintenanceForwarding'] });
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({
          setMessages,
        })(error);
      }
    },
  });

  return (
    <>
      <Button
        variant="yellow"
        operationKlassToCheckPermission="Admin::Maintenance::EstablishmentChoice::ManualEntryProposals::ClientReject"
        onClick={() => clientReject()}
        isLoading={clientRejectIsPending}
      >
        Declinar
      </Button>

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  );
}

export default ManualEntryProposalsClientReject;
